export default __webpack_public_path__ + "static/media/run.fd27b0e0.svg";